// reducer.js
/*import { LOAD_JOYRIDE_STEPS, SET_CURRENT_STEPS } from '../actions/userGuideActionTypes';

const initialState = {
  allSteps: [],
  currentSteps: [],
};

const userGuideReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_JOYRIDE_STEPS:
      return {
        ...state,
        allSteps: action.payload,
      };
    case SET_CURRENT_STEPS:
      return {
        ...state,
        currentSteps: action.payload,
      };
    default:
      return state;
  }
};

export default userGuideReducer;

*/


// userGuideReducer.js
import { LOAD_JOYRIDE_STEPS, SET_CURRENT_STEPS, START_TOUR, STOP_TOUR, NEXT_STEP, SET_TOUR_STATE } from '../actions/userGuideActionTypes';

const initialState = {
  allSteps: [],
  currentSteps: [],
  isRunning: false,
  currentStep: 0,
  isNavigating: false,
  isWaitingForElement: false,
  isStepReady: false,
  lastStepPrepared: null,
};

const userGuideReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_JOYRIDE_STEPS:
      return {
        ...state,
        allSteps: action.payload,
      };
    case SET_CURRENT_STEPS:
      return {
        ...state,
        currentSteps: action.payload,
      };
    case START_TOUR:
      return {
        ...state,
        isRunning: true,
        currentStep: 0,
        isStepReady: false,
        isNavigating: false,
        isWaitingForElement: false,
        lastStepPrepared: null,
      };
    case STOP_TOUR:
      return {
        ...state,
        isRunning: false,
        currentStep: 0,
        isStepReady: false,
        isNavigating: false,
        isWaitingForElement: false,
        lastStepPrepared: null,
      };
    case NEXT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 1,
        isStepReady: false,
      };
    case SET_TOUR_STATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default userGuideReducer;
